import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Activity, Search } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Login = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchQuery = location.state?.searchQuery || '';
  const [isChecking, setIsChecking] = useState(true);

  // Check if user is already authenticated
  useEffect(() => {
    const checkExistingAuth = async () => {
      try {
        const response = await axios.get(`${API}/auth/me`, {
          withCredentials: true
        });
        if (response.data && response.data.email) {
          // User is already authenticated, redirect to dashboard
          navigate('/dashboard', { replace: true });
          return;
        }
      } catch (error) {
        // Not authenticated, show login page
        console.log('User not authenticated, showing login');
      }
      setIsChecking(false);
    };

    checkExistingAuth();
  }, [navigate]);

  const handleGoogleLogin = () => {
    // Store search query for after authentication if present
    if (searchQuery) {
      localStorage.setItem('medplexity_pending_search', searchQuery);
    }
    
    // Always redirect to origin - AuthCallback will handle role check
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  // Show loading while checking auth
  if (isChecking) {
    return (
      <div className="landing-container" data-testid="login-page-loading">
        <div className="landing-content">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="loading-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="landing-container" data-testid="login-page">
      <div className="landing-content">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', marginBottom: '1rem' }}>
          <Activity size={64} color="#0277bd" />
          <h1 className="landing-title" style={{ marginBottom: 0 }}>MedPlexity</h1>
          <span className="beta-badge">Beta</span>
        </div>
        <p className="landing-subtitle">
          One-Stop AI-Powered Disease Intelligence & Patient Support Platform
        </p>
        
        {searchQuery && (
          <div style={{ 
            marginTop: '1.5rem', 
            padding: '1rem 1.5rem', 
            background: 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            maxWidth: '500px',
            margin: '1.5rem auto'
          }}>
            <Search size={20} color="#667eea" />
            <span style={{ color: '#37474f' }}>
              Sign in to search for: <strong style={{ color: '#667eea' }}>{searchQuery}</strong>
            </span>
          </div>
        )}
        
        <div style={{ marginTop: '2rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1.5rem' }}>
          <button
            onClick={handleGoogleLogin}
            className="google-login-btn"
            data-testid="google-login-btn"
          >
            <img 
              src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
              alt="Google" 
              style={{ width: '24px', height: '24px' }}
            />
            Sign in with Google
          </button>
          
          <p style={{ color: '#78909c', fontSize: '0.9rem', maxWidth: '500px', textAlign: 'center' }}>
            By signing in, you agree to our Terms of Service and Privacy Policy.
            Your health data is encrypted and secure.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
